
<template>
  <div>
    <div class="title">
      Pagamento por Bônus
    </div>
    <v-form readonly v-if="item">
      <v-text-field readonly :value="Number(item.value).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})" prepend-icon="mdi-search" label="Valor"></v-text-field>
      <v-text-field readonly :value="$moment(item.payment_date).format('DD/MM/YYYY HH:mm')" prepend-icon="mdi-search" label="Pago em"></v-text-field>
      
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'BonusDetail',
  props: {
    item: {
      type: Object,
    },
  },
}
</script>